// hooks/useFilters.js
import { useState, useEffect } from 'react';
import { API_CONSTANTS } from '../utils/constants';

export const useFilters = () => {
  const [filters, setFilters] = useState(() => {
    try {
      const savedFilters = localStorage.getItem('dashboardFilters');
      if (savedFilters) {
        let parsedFilters = JSON.parse(savedFilters);
        
        if (parsedFilters.startDate && typeof parsedFilters.startDate === 'string') {
          parsedFilters.startDate = new Date(parsedFilters.startDate);
        }
        if (parsedFilters.endDate && typeof parsedFilters.endDate === 'string') {
          parsedFilters.endDate = new Date(parsedFilters.endDate);
        }
        
        return parsedFilters;
      }
    } catch (error) {
      console.error('Error restoring filters:', error);
    }
    
    return API_CONSTANTS.INITIAL_FILTERS;
  });

  useEffect(() => {
    try {
      localStorage.setItem('dashboardFilters', JSON.stringify({...filters, complaint_numbers: ["NA"]}));
    } catch (error) {
      console.error('Error saving filters:', error);
    }
  }, [filters]);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const updateFilters = (newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  };

  const resetFilters = () => {
    setFilters(API_CONSTANTS.INITIAL_FILTERS);
    localStorage.removeItem('dashboardFilters');
  };

  return {
    filters,
    handleFilterChange,
    updateFilters,
    resetFilters
  };
};